/**
 * Local-dev fallback for the role → permissions map.
 *
 * In production this mapping lives in the BACKEND and is sent down per-user
 * inside `user.permissions` from /auth/login and /auth/me. Do NOT import this
 * file in production code paths — it is only used by the mock auth helpers
 * in `mocks/auth.mock.ts` when the backend is not yet wired up.
 */
import { PERMISSIONS, type Permission } from '@/auth/permissions'
import { ROLES, type Role } from '@/auth/roles'

export const MOCK_ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  super_admin: Object.values(PERMISSIONS),
  admin: [
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_CREATE,
    PERMISSIONS.USERS_UPDATE,
    PERMISSIONS.USERS_DELETE,
    PERMISSIONS.PRODUCTS_VIEW,
    PERMISSIONS.PRODUCTS_MANAGE,
    PERMISSIONS.ORDERS_VIEW,
    PERMISSIONS.ORDERS_MANAGE,
    PERMISSIONS.SETTINGS_MANAGE,
  ],
  manager: [
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.PRODUCTS_VIEW,
    PERMISSIONS.PRODUCTS_MANAGE,
    PERMISSIONS.ORDERS_VIEW,
    PERMISSIONS.ORDERS_MANAGE,
  ],
  support: [PERMISSIONS.USERS_VIEW, PERMISSIONS.ORDERS_VIEW],
  viewer: [PERMISSIONS.PRODUCTS_VIEW, PERMISSIONS.ORDERS_VIEW],
}

export function mockPermissionsForRole(role: Role | undefined): Permission[] {
  if (!role) return []
  return MOCK_ROLE_PERMISSIONS[role] ?? []
}

export const MOCK_ROLES = ROLES
